import type { FrequencyData } from '../services/AudioManager';

const LOW_FREQUENCY = 10;
const MID_FREQUENCY = 250;
const HIGH_FREQUENCY = 2000;

function average(data: Uint8Array, start: number, end: number): number {
  let sum = 0;
  let count = 0;
  for (let i = start; i < end && i < data.length; i += 1) {
    sum += data[i];
    count += 1;
  }
  return count > 0 ? sum / count : 0;
}

function normalize(value: number): number {
  return Math.min(value / 255, 1);
}

export function readAnalyserFrequencyData(
  analyser: AnalyserNode,
  dataArray: Uint8Array,
  sampleRate: number,
): FrequencyData {
  analyser.getByteFrequencyData(dataArray);
  const bufferLength = dataArray.length;

  const lowStart = Math.floor((LOW_FREQUENCY * bufferLength) / sampleRate);
  const lowEnd = Math.floor((MID_FREQUENCY * bufferLength) / sampleRate);
  const midEnd = Math.floor((HIGH_FREQUENCY * bufferLength) / sampleRate);

  const lowAvg = average(dataArray, lowStart, lowEnd);
  const midAvg = average(dataArray, lowEnd, midEnd);
  const highAvg = average(dataArray, midEnd, bufferLength);
  const overallAvg = average(dataArray, 0, bufferLength);

  return {
    low: normalize(lowAvg),
    mid: normalize(midAvg),
    high: normalize(highAvg),
    overall: normalize(overallAvg),
  };
}
